import { Text } from '@mantine/core';
import { Content, Header, Wrapper } from './SectionTitleCompact.style';

export type SectionTitleCompactProps = {
  title: string;
  description?: string;
  children?: React.ReactNode;
  gradient?: IModel;
  compact?: boolean;
};

export function SectionTitleCompact(props: SectionTitleCompactProps) {
  const { title, description, gradient = { from: 'pink', to: 'white' }, compact } = props;

  return (
    <Wrapper className='SectionTitleCompact-wrapper' data-testid='SectionTitleCompact-wrapper'>
      <Header>
        {/* @ts-ignore */}
        <Text component='h2' fw={800} variant='gradient' gradient={{ ...gradient, deg: 90 }}>
          {title}
        </Text>
        <Text component='span' size='md' fw={400} c='dimmed'>
          {description}
        </Text>
      </Header>
      <Content>{props.children}</Content>
    </Wrapper>
  );
}

export default SectionTitleCompact;
